import React, { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'

import { capitalizeFirstLetter } from 'utils/text'

import { getMenuByPeriodId } from '../api/getMenuByPeriodId'
import { useWelcomeTracking } from '../hooks/useWelcomeTracking'
import { WhatHappenNext } from './WhatHappenNext/WhatHappenNext'

import css from './OrderSchedule.css'

const propTypes = {
  deliveryDate: PropTypes.string.isRequired,
  nameFirst: PropTypes.string,
  whenCutoff: PropTypes.string.isRequired,
  interval: PropTypes.string,
  numRecipes: PropTypes.number.isRequired,
  numPortions: PropTypes.number.isRequired,
  showOrderSummary: PropTypes.bool,
  periodId: PropTypes.string,
}

const defaultProps = {
  nameFirst: '',
  interval: 'weekly',
  showOrderSummary: true,
  periodId: '',
}

const isValidDate = (date) => (date && date.length) || typeof date === 'object'

const OrderSchedule = ({
  deliveryDate,
  nameFirst,
  whenCutoff,
  interval,
  numRecipes,
  numPortions,
  showOrderSummary,
  periodId,
}) => {
  const isValidDeliveryDate = isValidDate(deliveryDate)
  const isValidWhenCutoff = isValidDate(deliveryDate)

  const isFiveForFourOrder = numRecipes === 5 && numPortions === 4
  const { trackWelcomePageLanded } = useWelcomeTracking()
  const hasTrackedPageChangeRef = useRef(false)

  useEffect(() => {
    let cancelled = false

    async function trackMenu() {
      if (!periodId) return
      const usersMenuFromPeriodId = await getMenuByPeriodId(periodId)
      if (cancelled) return

      if (!hasTrackedPageChangeRef.current && usersMenuFromPeriodId) {
        hasTrackedPageChangeRef.current = true
        trackWelcomePageLanded({
          firstOrderWeek: usersMenuFromPeriodId,
          newLocation: window.location.href,
        })
      }
    }

    trackMenu()

    return () => {
      cancelled = true
    }
  }, [periodId, trackWelcomePageLanded])

  return (
    <div data-testing="orderScheduleContainer" className={css.container}>
      <div className={css.header}>
        <h2>{`Congrats on choosing your first recipes, ${capitalizeFirstLetter(
          nameFirst || '',
        )}!`}</h2>
        <p className={css.headerSpacing}>
          We&apos;ll send you an email with tracking information when your first order is on its
          way.
        </p>
        <h2>What happens next?</h2>
      </div>
      <WhatHappenNext
        deliveryDate={deliveryDate}
        whenCutoff={whenCutoff}
        interval={interval}
        isFiveForFourOrder={isFiveForFourOrder}
        isValidWhenCutoff={isValidWhenCutoff}
        isValidDeliveryDate={isValidDeliveryDate}
        showOrderSummary={showOrderSummary}
      />
    </div>
  )
}

OrderSchedule.propTypes = propTypes
OrderSchedule.defaultProps = defaultProps

export { OrderSchedule }
